import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import {
  Icon,
  Modal,
  Form,
  Grid,
  GridColumn,
  Label,
  Button
} from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { fetchBranchMappingData,updateBranchMappingData} from "../../actions/users_action";

class BranchMapping extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: [],
      pageSize: 15,
      master:[],
      templateId:'',
      templates:[],
      selectedTemplate:'',
      modalOpen:false,
      siteName:'',
      location:'',
      finalBranch:'',
      psr:'',
      clusterMaster:'',
      channel1Target:'',
      soorma:'',
      dgpTarget:''
    };
  }

  componentDidMount() {
      
    this.props.fetchBranchMappingData({
        onSuccess:(res)=>{
            this.setState({master:res.result})
        },
        onFailure:()=>{

        }
    
      })
  }

  closeModal = () =>{
    this.setState({modalOpen:false})
  }

  siteNameChange = (e) =>{
    this.setState({siteName:e.target.value})
  }
  locationChange = (e) =>{
    this.setState({location:e.target.value})
  }
  finalBranchChange = (e) =>{
    this.setState({finalBranch:e.target.value})
  }
  psrChange = (e) =>{
    this.setState({psr:e.target.value})
  }
  clusterMasterChange = (e) =>{
    this.setState({clusterMaster:e.target.value})
  }
  channel1TargetChange = (e) =>{
    this.setState({channel1Target:e.target.value})
  }
  soormaOnChange = (e) =>{
    this.setState({soorma:e.target.value})
  }
  dgpTargetChange=(e)=>{
    this.setState({dgpTarget:e.target.value})
  }

  addNewBranch = ()=>{
    this.setState({modalOpen:true})
  }

  saveNewBranch = () => {
    let data = {
        "Site Name" : this.state.siteName,
        "Location" : this.state.location,
        "Final Branch" : this.state.finalBranch,
        "PSR" : this.state.psr,
        "Cluster Master" : this.state.clusterMaster,
        "channel 1 target" : this.state.channel1Target,
        "Soorma" : this.state.soorma,
        "DGP Target" : this.state.dgpTarget
    }
    this.props.updateBranchMappingData(data,
        {
            onSuccess:()=>{
                this.setState({modalOpen:false})
                this.props.fetchBranchMappingData({
                    onSuccess:(res)=>{
                        this.setState({master:res.result})
                    },
                    onFailure:()=>{
            
                    }
                
                  })
            },
            onFailure:()=>{

            }
        }
        )
  }

  
  render() {


    var columns = [
        {
          Header: "Site Name",
          accessor: "Site Name",
        },
        {
          Header: "Location",
          accessor: "Location",
        },
        {
          Header: "Final Branch",
          accessor: "Final Branch",
        },
        {
          Header: "PSR",
          accessor: "PSR",
        },
        {
            Header: "Cluster Master",
            accessor: "Cluster Master",
        },
        {
            Header: "Channel 1 target",
            accessor: "channel 1 target",
        },
        {
            Header: "Soorma",
            accessor: "Soorma",
        },
        {
            Header: "DGP Target",
            accessor: "DGP Target",
        },

    ]

    return (
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          flexFlow: "column",
          height: "86vh",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        
          <div style={{ height: '100%', flex: 1 }} >

          <h1
            style={{
              
              flex: "0 0 30px",
              display: "inline-block",
              color: "#2185d0",
            }}
          >
            Branch Mapping Data
          </h1>
          <br />
          <div style={{ marginLeft: 30 }}>
                <Label
                    style={{ justifyContent: 'flex-end', cursor: "pointer" }}
                    size="large"
                    color="blue"
                    onClick={this.addNewBranch}
                >
                    <Icon name="plus" />
                    Add Branch
                </Label>
                </div>
             
          {this.state.master.length > 0  && 
          
          <div style={{ display: "flex", overflowX: "scroll", marginTop: 20 }}>
          <ReactTable
            noDataText="We couldn't find anything"
            filterable={true}
            defaultPageSize={20}
            sortable={true}
            style={{ width: "85vw", marginLeft: 30 }}
            columns={columns}
            data={this.state.master}
          />
        </div>
            
          }


          </div>

          <Modal
            open={this.state.modalOpen}
            onClose={this.closeModal}
            size="small"
          >
            <Modal.Content>
              <Form>
                <Grid columns={2}>
                  <Grid.Row>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="text"
                        label="Site Name"
                        value={this.state.siteName}
                        onChange={(e) => this.siteNameChange(e)}
                        placeholder="Site Name"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="text"
                        label="Location"
                        value={this.state.location}
                        onChange={(e) => this.locationChange(e)}
                        placeholder="Location"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="Final Branch"
                        value={this.state.finalBranch}
                        onChange={(e) => this.finalBranchChange(e)}
                        placeholder="Final Branch"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="PSR"
                        value={this.state.psr}
                        onChange={(e) => this.psrChange(e)}
                        placeholder="PSR"
                      />
                    </Grid.Column>
                    <Grid.Column style={{ marginTop: 20 }}>
                      <Form.Input
                        type="any"
                        label="Cluster Master"
                        value={this.state.clusterMaster}
                        onChange={(e) => this.clusterMasterChange(e)}
                        placeholder="Cluster Master"
                      />
                    </Grid.Column>
                   
                    <GridColumn style={{ marginTop: 20 }}>
                    <Form.Input
                        type="any"
                        label="Channel 1 Target"
                        value={this.state.channel1Target}
                        onChange={(e) => this.channel1TargetChange(e)}
                        placeholder="Channel 1 Target"
                      />
                    </GridColumn>
                    <GridColumn style={{ marginTop: 20 }}>
                    <Form.Input
                        type="any"
                        label="Soorma"
                        value={this.state.soorma}
                        onChange={(e) => this.soormaOnChange(e)}
                        placeholder="Soorma"
                      />
                    </GridColumn>
                    <GridColumn style={{ marginTop: 20 }}>
                    <Form.Input
                        type="any"
                        label="DGP Target"
                        value={this.state.dgpTarget}
                        onChange={(e) => this.dgpTargetChange(e)}
                        placeholder="DGP Target"
                      />
                    </GridColumn>
            
                  </Grid.Row>
                </Grid>
              </Form>
            </Modal.Content>
            <Modal.Actions style={{ marginTop: 20 }}>
              <Button color="red" onClick={this.closeModal}>
                <Icon name="remove" /> Cancel
              </Button>
              
                <Button
                  color="green"
                  disabled={this.state.siteName != '' && this.state.finalBranch != '' && this.state.channel1Target != '' && this.state.location != '' && this.state.psr != '' && this.state.dgpTarget != '' && this.state.clusterMaster != ''? false : true}
                  onClick={this.saveNewBranch}
                >
                  Save
                </Button>
            </Modal.Actions>
          </Modal>

      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
        fetchBranchMappingData,
        updateBranchMappingData
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BranchMapping)
);
